import './Game.scss';
import store, { RootState } from '../store';
import { useAppSelector } from '../redux'
import { gameActions } from './gameSlice';
import SpritesheetAsset from '../Components/SpritesheetAsset';


function StatusBar() {

  const gameState = useAppSelector((state: RootState) => state.game);

  function showScoreboard() {
    store.dispatch(gameActions.showScoreboard());
  }

  function showHelp() {
    store.dispatch(gameActions.showHelp());
  }

  return (
    <div className="status-bar">
      <div className='status-bar-status'>Level {gameState.level} - Stage {gameState.stage} {gameState.levelFullName}</div>
      <div className='status-bar-icons'>
        <SpritesheetAsset onClick={showScoreboard} name="scoreboard-icon.png" multiplier={2} />
        <SpritesheetAsset onClick={showHelp} name="info-icon.png" multiplier={2} />
      </div>
    </div>
  );
}

export default StatusBar;
